import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=c4f575a6&"
import script from "./QRCode.vue?vue&type=script&lang=js&"
export * from "./QRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4f575a6')) {
      api.createRecord('c4f575a6', component.options)
    } else {
      api.reload('c4f575a6', component.options)
    }
    module.hot.accept("./QRCode.vue?vue&type=template&id=c4f575a6&", function () {
      api.rerender('c4f575a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/QRCode.vue"
export default component.exports